import { render, staticRenderFns } from "./caseItem.vue?vue&type=template&id=542dd254&scoped=true"
import script from "./caseItem.vue?vue&type=script&lang=js"
export * from "./caseItem.vue?vue&type=script&lang=js"
import style0 from "./caseItem.vue?vue&type=style&index=0&id=542dd254&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542dd254",
  null
  
)

export default component.exports